import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetProductCategories = function () {
    return useApiCall(function (signal) { return api.configuration.apiConfigurationProductCategoryGet({ signal: signal }); }, null, true, []);
};
